<template>
  <b-container class="districts">
    <div class="district-wrap">

      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 285.03 130.0">

        <g transform="translate(0,12)" class="a" v-for="county in counties" :key="county.name">
          <polygon :points="county.points" class="b" :class="{selected: isCountySelected}"
                   @click="clickCounty(county)"></polygon>

        </g>
        <g :transform="`scale(${schoolhouseTransform.scale}) translate(0, -8) `">
          <image :height="schoolhouseTransform.height" :width="schoolhouseTransform.width" :x="schoolhouseTransform.x"
                 :y="schoolhouseTransform.y"
                 :href="schoolhouseImgSrc"/>
        </g>
        <!-- wifi signal -->
        <g class="wifi" :transform="'translate('+ wifiTranslateX +','+ wifiTranslateY +')  scale(.4)'">
          <path class="signal signal-bottom" :class="{active: wifiSignalBarBottom}"
                d="M18.6,13.5a12.58,12.58,0,0,1,9,3.48l-.84.89a11.39,11.39,0,0,0-16.09.38l-.88-.85A12.53,12.53,0,0,1,18.6,13.5Z"/>
          <path class="signal signal-middle" :class="{active: wifiSignalBarMiddle}"
                d="M18.44,6.64A19.45,19.45,0,0,1,32.33,12L31,13.38A17.61,17.61,0,0,0,6.17,14l-1.36-1.3A19.42,19.42,0,0,1,18.44,6.64Z"/>
          <path class="signal signal-top" :class="{active: wifiSignalBarTop}"
                d="M18.28,0a26,26,0,0,1,18.64,7.2L35.17,9a23.62,23.62,0,0,0-33.34.78L0,8.08A26,26,0,0,1,18.28,0Z"/>
        </g>
      </svg>
      <div class="super-graphics">
        <b-row>
          <b-col>
            <div class="county-name">{{ countyName }}</div>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" lg="4">
            <div class="school-districts"><span class="number">{{ numSchoolDistricts }}</span> {{ 'District' | pluralize(numSchoolDistricts) }}</div>
          </b-col>
          <b-col cols="12" lg="4">
            <div class="schools"><span class="number">{{ numSchools }}</span> Schools</div>
          </b-col>
          <b-col cols="12" lg="4" class="students"><span class="number">{{ numStudents }}</span> Students</b-col>
        </b-row>
      </div>
    </div>
  </b-container>
</template>

<script>

const counties = [
  {
    name: 'Pulaski',
    points: '191.79 22.18 141.52 22.02 143.86 0.58 199.75 0.59 207.85 22.13 191.79 22.18',
    center: {x:156, y:2},
    numSchoolDistricts: 4,
    numSchools: 7,
    numStudents: 3742,
  },
  {
    name: 'Cass',
    points: '276.51 50.29 238.69 50.45 232.29 40.02 207.97 39.99 206.29 36.47 196.74 36.36 191.79 22.18 207.85 22.13 253.05 22.01 276.51 50.29',
    center: {x:218, y:25},
    numSchoolDistricts: 4,
    numSchools: 15,
    numStudents: 7356,
  },
  {
    name: 'White',
    points: "107.69 50.49 111.84 36.55 114.28 28.18 132.38 27.99 133.39 22.04 141.52 22.02 191.79 22.18 196.74 36.36 169.65 36.28 166.77 37.76 165.75 39.75 167.26 42.18 165.61 42.24 165.89 50.5 107.69 50.49",
    center: {x:132, y:28},
    numSchoolDistricts: 4,
    numSchools: 15,
    numStudents: 4694,
  },
  {
    name: 'Carroll',
    points: "244.37 62.2 181.34 61.61 179.75 50.68 165.89 50.5 165.61 42.24 167.26 42.18 165.75 39.75 166.77 37.76 169.65 36.28 196.74 36.36 206.29 36.47 207.97 39.99 232.29 40.02 238.69 50.45 244.37 62.2",
    center: {x:187, y:42},
    numSchoolDistricts: 2,
    numSchools: 6,
    numStudents: 2471,
  },
  {
    name: 'Benton',
    points: "23.36 57.33 41.4 36.46 84.99 36.6 111.84 36.55 107.69 50.49 104.88 58.48 22.86 58.27 23.36 57.33",
    center: {x:55, y:40},
    numSchoolDistricts: 1,
    numSchools: 5,
    numStudents: 1731,
  },
  {
    name: 'Warren',
    points: "25.46 86.56 8.79 86.5 10.27 84.78 1.21 84.53 22.86 58.27 104.88 58.48 102.55 66.72 94.1 68.99 86.37 69.12 72.64 71.25 61.25 75.16 45.51 79.2 25.88 81.6 22.09 83.91 25.46 86.56",
    center: {x:28, y:60},
    numSchoolDistricts: 1,
    numSchools: 4,
    numStudents: 1304,
  },
  {
    name: 'Clinton',
    points: "183.8 82.5 183.28 79.61 181.34 61.61 244.37 62.2 257.63 62.27 260.02 65.58 266.41 65.69 267.41 66.86 273.69 66.7 281.84 79.36 284 82.92 183.8 82.5",
    center: {x:211, y:63},
    numSchoolDistricts: 4,
    numSchools: 10,
    numStudents: 6300,
  },
    {
    name: 'Fountain',
    points: "90.71 101.58 17.66 101.28 12.32 102.04 10.41 100.45 13.62 98.93 13.2 96.79 16.93 93.32 20.76 91.95 25.46 86.56 22.09 83.91 25.88 81.6 45.51 79.2 61.25 75.16 72.64 71.25 86.37 69.12 94.1 68.99 102.55 66.72 98.72 79.42 90.71 101.58",
    center: {x:45, y:75},
    numSchoolDistricts: 3,
    numSchools: 8,
    numStudents: 2586,
  },
  {
    name: 'Montgomery',
    points: "185.63 108.44 109.08 108.43 89.15 108.45 90.71 101.58 98.72 79.42 183.28 79.61 183.8 82.5 185.52 103.82 185.63 108.44",
    center: {x:122, y:82},
    numSchoolDistricts: 3,
    numSchools: 11,
    numStudents: 6181,
  },
    {
    name: 'Tippecanoe',
    points: "165.89 50.5 107.69 50.49 104.88 58.48 102.55 66.72 98.72 79.42 183.28 79.61 181.34 61.61 179.75 50.68 165.89 50.5",
    center: {x:126, y: 55},
    numSchoolDistricts: 3,
    numSchools: 55,
    numStudents: 23977,
  },
]

const schoolhouseWidth = 15;
const schoolHouseHeight = 15;

const schoolhouseImgs = [
    "/img/schoolhouse1.png",
    "/img/2.png",
    "/img/3.png",
    "/img/4.png",
    "/img/5.png",
]

export default {
  name: 'CountySchoolDistrictAnimation',
  props: {},
  data: function() {
    // svg image paths need this
    const publicPath = (process.env.BASE_URL !== '/') ? process.env.BASE_URL: '';

    // Randomize the cycle through the counties for animation.
    let loopOrder = [];
    let unusedCounties = [...counties];
    for (let i = 0; i < counties.length; i += 1) {
      let r = Math.floor(Math.random() * unusedCounties.length);
      const c = unusedCounties[r];
      unusedCounties = unusedCounties.filter(x => x !== c)
      loopOrder.push(c);
    }

    return {
      publicPath: publicPath,

      counties: loopOrder,

      selectedCounty: null,
      interactingWithCounties: false,
      schoolhouseTransform: {
        height: schoolHouseHeight,
        width: schoolhouseWidth,
        x: 0,
        y: 0,
        scale: 1.15,
      },
      schoolhouseImgSrc: publicPath + schoolhouseImgs[0],
      wifiFrame: 1,
      wifiSignalBarTop: false,
      wifiSignalBarMiddle: false,
      wifiSignalBarBottom: false,
    };
  },
  mounted() {
    // Highlight the next county every interval
    window.setInterval(() => {
      this.highlightNextCounty();
    }, 2560)

    // Animate the wifi signal
    window.setInterval(() => {
      this.highlightNextSignalBar(this.wifiFrame);
      this.wifiFrame += 1;
    }, 2560/16)

    this.highlightNextCounty();
  },
  filters: {
    pluralize(value, num) {
      if (num === 1) {
        return value;
      } else {
        return `${value}s`;
      }
    }
  },
  methods: {
    isCountySelected(county) {
      return this.selectedCounty === county;
    },
    highlightNextCounty() {
      if (this.interactingWithCounties) {
        return;
      }
      this.resetWifiAnimation();
      //const county = counties[Math.floor(Math.random() * 10)];
      let nextIndex = this.counties.indexOf(this.selectedCounty) + 1;
      if (nextIndex >= this.counties.length) {
        nextIndex = 0;
      }

      this.highlightCounty(this.counties[nextIndex]);
    },

    resetWifiAnimation() {
      this.wifiFrame = 1;
      this.wifiSignalBarTop = false;
      this.wifiSignalBarMiddle = false;
      this.wifiSignalBarBottom = false;
    },

    highlightNextSignalBar(frame) {

      if (this.wifiSignalBarBottom && this.wifiSignalBarMiddle && this.wifiSignalBarTop && frame % 8 === 0) {
        this.wifiSignalBarBottom = false;
        this.wifiSignalBarMiddle = false;
        this.wifiSignalBarTop = false;
      } else if (!this.wifiSignalBarBottom && !this.wifiSignalBarMiddle && !this.wifiSignalBarTop) {
        this.wifiSignalBarBottom = true;
      } else if (this.wifiSignalBarBottom && !this.wifiSignalBarMiddle) {
        this.wifiSignalBarMiddle = true;
      } else if (this.wifiSignalBarBottom && this.wifiSignalBarMiddle && !this.wifiSignalBarTop) {
        this.wifiSignalBarTop = true;
      }
    },

    highlightCounty(county) {
      if (this.selectedCounty === county) {
        return;
      }

      this.selectedCounty = county;

      this.moveSchoolHouseToCoord(county.center);
    },

    clickCounty(county) {
      this.interactingWithCounties = true;
      this.highlightCounty(county);
    },

    moveSchoolHouseToCoord({x, y}) {
      // Find middle
      const adj_x = 1/this.schoolhouseTransform.scale*(x + Math.floor(schoolhouseWidth / 2));
      const adj_y = 1/this.schoolhouseTransform.scale*(y + schoolHouseHeight);
      this.schoolhouseTransform.x = adj_x;
      this.schoolhouseTransform.y = adj_y;
      this.schoolhouseImgSrc = this.publicPath + schoolhouseImgs[Math.floor(Math.random()*schoolhouseImgs.length)];
    },

    isWifiBarActive(index) {
      return this.wifiSignalBars[index];
    }
  },
  computed: {
    countyName() {
      if (this.selectedCounty !== null) {
        return this.selectedCounty.name;
      }
      return "";
    },
    numSchoolDistricts() {
      return (this.selectedCounty !== null) ? this.selectedCounty.numSchoolDistricts : "";
    },
    numSchools() {
      return (this.selectedCounty !== null) ? this.selectedCounty.numSchools : "";
    },
    numStudents() {
      return (this.selectedCounty !== null) ? numberWithCommas(this.selectedCounty.numStudents) : "";
    },

    wifiTranslateX() {
      return (this.selectedCounty !== null) ? this.selectedCounty.center.x + 8 : 0;
    },
    wifiTranslateY() {
      return (this.selectedCounty !== null) ? this.selectedCounty.center.y - 1 : 0;
    }
  }
}

// utility: references https://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

</script>

<style lang="scss" scoped>


h3 {
  color: #808285;
  font-size: 175%;
  font-family: 'Aero Matics', sans-serif;
  font-weight: 400;
}

p {
  font-family: "Aaux ProRegular", sans-serif;
  font-size: 125%;
}

button {
  min-width: 10rem;
  padding: .5rem;
  text-transform: uppercase;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  font-weight: 500;
}

/* District animation */
.district-wrap {
  position: relative;
  user-select: none;
}

.b {
  opacity: 0.38;
  fill: #60cae7;
  stroke: #fff;
  stroke-miterlimit: 10;
  stroke-width: 1.16px;
  transition: opacity .33s ease-in-out, fill .33s ease-in-out;
}


.super-graphics {
  text-align: right;
  color: #00bfb0;
  font-family: "bebas_neueregular", cursive;
  font-size: 250%;
  text-transform: uppercase;
  line-height: 400%;
}

.super-graphics .county-name {
  text-align: center;
  color: #60CAE7;
  font-size: 200%;
  line-height: 100%;
}

.super-graphics .number {
  font-size: 250%;
}

.super-graphics .students .number {
  font-size: 250%;

}

@media (max-width: 999px) {
  .super-graphics {
    text-align: center;
    font-size: 250%;
    line-height: 250%;
  }
  .super-graphics .number {
    font-size: 200%;
  }
  .super-graphics .students .number {
    font-size: 200%;
  }
}

@media (max-width: 1199px) {
  .super-graphics {
    text-align: center;
    font-size: 200%;
    line-height: 200%;
  }
}

.wifi {
  pointer-events: none;
}

.wifi .signal {
  fill: transparent;
}
.wifi .signal.active {
  fill: #2AB3A7;
}

</style>